import { doc, getDoc } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { firestore } from '../../../firebase.config';

/**
 * Le document brut d'une collection, tel qu'il est stocké — aucun mapping,
 * aucun modèle. Sert au débogage : ce qu'on lit à l'écran doit être exactement
 * ce qui est en base, un modèle intermédiaire masquerait justement le champ
 * qu'on cherche.
 */
async function getRawDocument(
  collection: string,
  documentId: string,
): Promise<Record<string, unknown> | null> {
  try {
    const snapshot = await getDoc(doc(firestore, collection, documentId));
    if (!snapshot.exists()) return null;
    return snapshot.data() as Record<string, unknown>;
  } catch (e) {
    console.log('error: ', e);
    throw new GetRawDocumentFailure();
  }
}

export class GetRawDocumentFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getRawDocument;
